import LandingFooter from "components/LandingFooter/LandingFooter";
import type { ReactNode } from "react";
import Header from "../Header/Header";

const TicketingLayout = ({
  children,
  footer = false,
  header,
}: {
  children?: ReactNode;
  footer?: boolean;
  header?: ReactNode;
}) => {
  return (
    <div className="min-h-screen w-screen relative bg-[url('/images/auth-bg.svg')] bg-cover dark:bg-neutral-900 bg-neutral-10 bg-center bg-no-repeat">
      <div className="flex flex-col flex-grow min-h-screen">
        {header ? header : <Header />}
        <div
          className="flex flex-col flex-grow p-0 h-full relative "
          style={{
            background:
              "linear-gradient(224deg, rgba(132,225,255,0.6) 0%, rgba(132,225,255,0.00) 100%)",
          }}
        >
          <main className="flex flex-col flex-grow relative z-0">
            {children}
          </main>
          {footer && <LandingFooter />}
        </div>
      </div>
    </div>
  );
};

export default TicketingLayout;
